import { Action, Dispatch } from 'redux'
import { db, FirebaseSnapshotType } from 'firebase/index'
import { dateToString } from 'lib/helper'
import { BasketType } from 'types/basket'
import { fetchBasketsAction } from 'reducks/basket/actions'

// スーパー管理者による注文の横断検索
const fetchBasketGroup = (startDate: Date, endDate: Date) => {
  return async (dispatch: Dispatch<Action>) => {
    const baskets = await db
      .collectionGroup('store_baskets')
      .orderBy('date', 'asc')
      .startAt(dateToString(startDate))
      .endAt(dateToString(endDate))
      .limit(100)
      .get()
      .then((snapshots) => {
        const baskets: BasketType[] = []
        snapshots.forEach((snapshot: FirebaseSnapshotType) => {
          const data = snapshot.data() as BasketType
          data.basket_id = snapshot.id
          baskets.push(data)
        })
        return baskets
      })
    dispatch(fetchBasketsAction(baskets))
  }
}

export default fetchBasketGroup
